import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import styles from "./RespawnScreen.module.css";
import { useGame } from "../store/game";
import { useHaptic } from "../hooks/useHaptic";

type Boost = { type: "fast" | "turbo" | "instant"; icon: string; name: string; desc: string; cost: number };

const BOOSTS: Boost[] = [
  { type: "fast",    icon: "⚡",  name: "Fast Respawn",  desc: "Відновлення за 30 хв",   cost: 10  },
  { type: "turbo",   icon: "⚡⚡", name: "Turbo",         desc: "Відновлення за 15 хв",   cost: 25  },
  { type: "instant", icon: "🔥",  name: "Instant",       desc: "Миттєве відновлення",     cost: 50  },
];

export function RespawnScreen() {
  const respawnAt = useGame((s) => s.respawnAt);
  const tokens = useGame((s) => s.tokens);
  const buyBoost = useGame((s) => s.buyBoost);
  const haptic = useHaptic();
  const [secondsLeft, setSecondsLeft] = useState(0);
  const [buying, setBuying] = useState<string | null>(null);

  useEffect(() => {
    if (!respawnAt) return;
    const tick = () => {
      const diff = Math.max(0, Math.floor((respawnAt.getTime() - Date.now()) / 1000));
      setSecondsLeft(diff);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [respawnAt]);

  const mm = String(Math.floor(secondsLeft / 60)).padStart(2, "0");
  const ss = String(secondsLeft % 60).padStart(2, "0");

  const handleBoost = async (b: Boost) => {
    if (tokens < b.cost) { haptic.notify("error"); return; }
    haptic.impact("heavy");
    setBuying(b.type);
    await buyBoost(b.type);
    setBuying(null);
  };

  return (
    <motion.div
      className={styles.overlay}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className={styles.icon}>💸</div>

      <div>
        <div className={styles.title}>Баланс вичерпано</div>
        <div className={styles.subtitle}>
          Відпочинь — або витрать GT токени щоб повернутись раніше
        </div>
      </div>

      <div className={styles.timer}>
        <div className={styles.timerLabel}>Відновлення через</div>
        <div className={styles.timerValue}>{mm}:{ss}</div>
        <div className={styles.timerMinutes}>хвилин : секунд</div>
      </div>

      <div className={styles.boosts}>
        {BOOSTS.map((b) => (
          <button
            key={b.type}
            type="button"
            className={styles.boostBtn}
            onClick={() => handleBoost(b)}
            disabled={buying !== null}
          >
            <div className={styles.boostLeft}>
              <span className={styles.boostIcon}>{b.icon}</span>
              <div>
                <div className={styles.boostName}>{b.name}</div>
                <div className={styles.boostDesc}>{b.desc}</div>
              </div>
            </div>
            <span className={styles.boostCost}>
              {buying === b.type ? "..." : `${b.cost} GT`}
            </span>
          </button>
        ))}
      </div>
    </motion.div>
  );
}
